import { MASCOT } from "@/lib/api";
import { AdvisorChat } from "@/components/AdvisorChat";

export default function Advisor() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 grid lg:grid-cols-[1fr_1.4fr] gap-10" data-testid="advisor-page">
      <div>
        <p className="text-[#DC2626] font-bold text-sm tracking-[0.2em] uppercase">Asesor FAUNNY · IA</p>
        <h1 className="font-display font-black text-5xl sm:text-6xl text-[#0B1D3A] mt-2 leading-none">Cuéntanos cómo es tu caballo</h1>
        <p className="text-slate-600 mt-4">Edad, actividad, qué le pasa o qué quieres conseguir. Dr. FAUNNY te recomienda los productos del catálogo con su formato y dosis.</p>
        <img src={MASCOT} alt="Dr. FAUNNY" className="mt-8 w-full max-w-sm aspect-square object-cover object-center rounded shadow-[0_30px_60px_-30px_rgba(11,29,58,0.6)] hidden lg:block" />
      </div>
      <div className="border border-slate-200 rounded h-[640px] overflow-hidden flex flex-col bg-white shadow-sm">
        <div className="bg-[#0B1D3A] text-white px-5 py-3 font-display font-bold text-lg">Chat con el Asesor FAUNNY</div>
        <div className="flex-1 min-h-0"><AdvisorChat /></div>
      </div>
    </div>
  );
}
